import { internalError } from '../constants';
import type { Tracker } from '../types/tracker';

export const datadogTracker: Tracker = {
  init: () => true,
  trackError: (error, details) => {
    if ( !window.DD_RUM?.addError) {
      return Promise.reject(internalError.init.datadog);
    }
    return Promise.resolve(window.DD_RUM.addError(error, details));
  },
  trackEvent: (eventName, details) => {
    if (!window.DD_RUM?.addAction) {
      return Promise.reject(internalError.init.datadog);
    }
    return Promise.resolve(window.DD_RUM.addAction(eventName, details));
  }
};
